import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'
import {ClientUserState} from './ClientUserState.ts'

export class HotjarLoader {
    private static initialized = false
    static init() {
        if(this.initialized) return

        if(UIUtilsEjsVariables.isUserOnDiscord) return
        if((ClientUserState.userState?.totalCompletedGameCount ?? 0) > 0) return
        if(window.location.protocol != 'https:') return

        (function(h: any, o: any, t: string, j: any, a?: any, r?: any) {
            h.hj = h.hj ?? function() {
                // eslint-disable-next-line prefer-rest-params
                (h.hj.q = h.hj.q ?? []).push(arguments)
            }
            h._hjSettings = {hjid: UIUtilsEjsVariables.hotjarTrackingCode, hjsv: 6}
            a = o.getElementsByTagName('head')[0]
            r = o.createElement('script'); r.async = 1
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
            a.appendChild(r)
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')

        this.initialized = true
    }
}
